import { ReactNode, useEffect, useRef } from 'react';
import { getCurrentUser } from '../api/auth.api';
import { authStorage } from './auth-storage';
import { useAppDispatch } from '../hooks/redux';
import { clearSession, setAuthLoading, setSession } from '../store/authSlice';
import { AuthSession } from '../types/api';

export function AuthInitializer({ children }: { children: ReactNode }) {
  const dispatch = useAppDispatch();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const stored = authStorage.get();

    if (!stored?.accessToken && !stored?.refreshToken) {
      dispatch(setAuthLoading(false));
      return;
    }

    dispatch(setAuthLoading(true));
    void getCurrentUser()
      .then((user) => {
        const session: AuthSession = { ...stored, user };
        authStorage.save(session);
        dispatch(setSession(session));
      })
      .catch(() => {
        authStorage.clear();
        dispatch(clearSession());
      })
      .finally(() => dispatch(setAuthLoading(false)));
  }, [dispatch]);

  return <>{children}</>;
}
